export default "__VITE_ASSET__DdTCEkv3__"